import { memo } from "react";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import { MENU_OPTION_COMPONENTS } from "../../lib/registry/menuOptionComponents";
import { MENU_OPTION_SPECIAL_COMPONENTS } from "../../lib/registry/menuOptionSpecialComponents";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";

interface MenuOptionProps {
    name: WidgetOptions;
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export const MenuOption = memo(function MenuOption({
    name,
    activeSubMenu,
    setActiveSubMenu,
}: MenuOptionProps) {
    const SpecialComponent = MENU_OPTION_SPECIAL_COMPONENTS[name];
    if (SpecialComponent) {
        return (
            <SpecialComponent
                name={name}
                activeSubMenu={activeSubMenu}
                setActiveSubMenu={setActiveSubMenu}
            />
        );
    }

    const Component = MENU_OPTION_COMPONENTS[name];
    if (Component) {
        return (
            <Component
                name={name}
                activeSubMenu={activeSubMenu}
                setActiveSubMenu={setActiveSubMenu}
            />
        );
    }
});
